// extracted by mini-css-extract-plugin
export default {"menu_side":"MenuSide_menu_side__tI8Gs"};